export const countries: { name: string; isoCode: string }[] = [
    {
        name: "Austria",
        isoCode: "AT"
    },
    {
        name: "Belarus",
        isoCode: "BY"
    },
    {
        name: "Belgium",
        isoCode: "BE"
    },
    {
        name: "Bulgaria",
        isoCode: "BG"
    },
    {
        name: "Croatia",
        isoCode: "HR"
    },
    {
        name: "Czech Republik",
        isoCode: "CZ"
    },
    {
        name: "Denmark",
        isoCode: "DK"
    },
    {
        name: "Finland",
        isoCode: "FI"
    },
    {
        name: "France",
        isoCode: "FR"
    },
    {
        name: "Germany",
        isoCode: "DE"
    },
    {
        name: "Greece",
        isoCode: "GR"
    },
    {
        name: "Hungary",
        isoCode: "HU"
    },
    {
        name: "Italy",
        isoCode: "IT"
    },
    {
        name: "Netherlands",
        isoCode: "NL"
    },
    {
        name: "Norway",
        isoCode: "NO"
    },
    {
        name: "Poland",
        isoCode: "PL"
    },
    {
        name: "Portugal",
        isoCode: "PT"
    },
    {
        name: "Romania",
        isoCode: "RO"
    },
    {
        name: "Serbia",
        isoCode: "RS"
    },
    {
        name: "Slovakia",
        isoCode: "SK"
    },
    {
        name: "Slovenia",
        isoCode: "SI"
    },
    {
        name: "Spain",
        isoCode: "ES"
    },
    {
        name: "Sweden",
        isoCode: "SE"
    },
    {
        name: "Switzerland",
        isoCode: "CH"
    },
    {
        name: "United Kingdom",
        isoCode: "GB"
    },
    {
        name: "United States",
        isoCode: "US"
    }
];
